import { BuildClass } from '../../../../universal';
import { React } from '../../../lib';
import { AddButton } from '../buttons';
import { FileUploadDropZone } from '../file-upload';
import { LoadingSpinnerLarge } from '../loading';
import { CJSX, useRSInstance } from '../meta-types';
import { ResizeSplitter } from '../resize-split';
import { stubFocusable, stubInput, stubListGrid } from '../stubs';
import { Toolbar } from '../toolbar';
import { addNewNoteForm } from './add';
import { bulkUploadNotes, getIgnoreChecksums } from './bulk-upload';
import { NoteDetails } from './details';
import { NoteList } from './list';
const getDefaultState = (p) => ({
    searchText: p.state?.searchText ?? '',
    showArchived: p.state?.showArchived ?? false,
    showDeleted: p.state?.showDeleted ?? false,
    showTagIndicators: p.state?.showTagIndicators ?? true,
    showCompactView: p.state?.showCompactView ?? false,
    filteredTags: p.state?.filteredTags ?? null,
    selectedNotes: p.state?.selectedNotes ?? [],
    paneSizes: p.state?.paneSizes ?? null,
    loadingCoverMessage: null,
});
export const NotesComponent = (props) => {
    const rs = useRSInstance({
        props,
        refs: {
            grid: React.useRef(stubListGrid),
            searchBox: React.useRef(stubFocusable(stubInput)),
        },
        defaultState: getDefaultState,
        actionToDelta: null,
    });
    const processUploadedFiles = async (filesAll) => new Promise(resolve => {
        bulkUploadNotes(rs, filesAll, resolve);
    });
    if (props.notes.length == 0) {
        return (React.createElement("div", { className: BuildClass(['tailwind-wrapper', props.className]), style: { height: '100%' } },
            React.createElement(FileUploadDropZone, { className: "h-full", multiple: true, disabled: !rs.props.adding?.bulkUpload, draggingOverMessage: rs.props.adding?.bulkUpload?.dragDropCoverMessage, ignoreChecksums: getIgnoreChecksums(rs), onUpload: processUploadedFiles },
                React.createElement(Toolbar, { widthRHS: 150, lhs: React.createElement(React.Fragment, null), rhs: React.createElement(AddButton, { lbl: "Add Content", onClick: () => {
                            addNewNoteForm(rs);
                        } }) }),
                React.createElement("div", { className: "cntr error_msg_2" }, "No Notes"))));
    }
    return (React.createElement("div", { className: BuildClass(['tailwind-wrapper', props.className]), style: { height: '100%' } },
        React.createElement(FileUploadDropZone, { className: "h-full", multiple: true, disabled: !rs.props.adding?.bulkUpload, draggingOverMessage: rs.props.adding?.bulkUpload?.dragDropCoverMessage, ignoreChecksums: getIgnoreChecksums(rs), onUpload: processUploadedFiles },
            React.createElement(CJSX, { cond: rs.state.loadingCoverMessage != null },
                React.createElement("div", { className: "absolute grid place-items-center w-full h-full z-10" },
                    React.createElement(LoadingSpinnerLarge, null),
                    React.createElement("div", { className: "text-2xl text-white" }, rs.state.loadingCoverMessage))),
            React.createElement(ResizeSplitter, { value: rs.state.paneSizes, onUpdate: v => {
                    rs.updateState({ paneSizes: v });
                    rs.props.state?.onUpdate?.({ paneSizes: v });
                }, panes: [
                    {
                        minWidth: 200,
                        maxWidth: null,
                        collapsible: true,
                        defaultWidth: 290,
                        flexWidth: null,
                        content: React.createElement(NoteList, { rs: rs }),
                    },
                    {
                        minWidth: 200,
                        maxWidth: null,
                        collapsible: true,
                        defaultWidth: null,
                        flexWidth: 1,
                        content: React.createElement(NoteDetails, { rs: rs }),
                    },
                ] }))));
};
//# sourceMappingURL=main.js.map